// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"a95fa06e","61":"1921814b","230":"6857f175","383":"d0486a46","460":"7d93b9b4","470":"81e93b0a","478":"58571fe2","564":"aa835e03","623":"9e92ccc9","770":"a210beea","852":"9b8468da","977":"44c822f7"}[chunkId] + ".chunk.js";
};